import { render } from "./ContentLayout.vue?vue&type=template&id=17ecb16c&scoped=true"
import script from "./ContentLayout.vue?vue&type=script&lang=js"
export * from "./ContentLayout.vue?vue&type=script&lang=js"

import "./ContentLayout.vue?vue&type=style&index=0&id=17ecb16c&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ecb16c"]])

export default __exports__